import React from "react";
import "components/General/Appearance.css";

class TextTheme extends React.Component {
	render() {
		return (
			<div
				className={this.props.className}
				style={[{
					top: this.props.top,
					position: this.props.position,
					transform: this.props.transform,
					right: this.props.right,
					textAlign: this.props.textAlign,
					color: this.props.color,
					fontSize: this.props.fontSize,
					marginTop: this.props.marginTop,
					marginBottom: this.props.marginBottom,
					clear:this.props.clear,
				}] ,{...this.props.styles}}
			>
				{/*the 'message' property is the only compulsory property to be declared while using this component*/}
				{this.props.message}
			</div>
		);
	}
}

export default TextTheme;
